import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { TitleState } from '../../state/title-state';
import { Observable } from 'rxjs';
import { ToggleGlobalLoader } from '../../../../state/app-state-actions';
import { Settings } from '../../../../../common/core/config/settings.service';
var EpisodePageComponent = /** @class */ (function () {
    function EpisodePageComponent(store, settings) {
        this.store = store;
        this.settings = settings;
    }
    EpisodePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        // TODO: remove settimout
        setTimeout(function () {
            _this.store.dispatch(new ToggleGlobalLoader(false));
        });
    };
    tslib_1.__decorate([
        Select(TitleState.episode),
        tslib_1.__metadata("design:type", Observable)
    ], EpisodePageComponent.prototype, "episode$", void 0);
    tslib_1.__decorate([
        Select(TitleState.backdrop),
        tslib_1.__metadata("design:type", Observable)
    ], EpisodePageComponent.prototype, "backdropImage$", void 0);
    return EpisodePageComponent;
}());
export { EpisodePageComponent };
